<div class="p-8">
    <app-loader *ngIf="isLoading"></app-loader>  
    <div class="bg-white rounded-lg p-8">
        <p class="text-xl font-bold mb-5 text-gray-800">
            <span>Edit Organization</span>
        </p>
        <p class="text-md mb-5">Fill the Details Of The Organization</p>
        <form [formGroup]="editOrgForm"  (ngSubmit)="onSubmit()">
            <div class="floating-input relative mb-10 flex flex-col">
                <label class="block text-sm font-medium text-gray-500 p-3">Organization Type*</label>
                <select formControlName="orgType" [ngClass]="outlineOrgType ? 'outline' : ''" (focus)="onFocus('orgType')">
                    <option value="">Select Org Type</option>
                    <ng-container>
                        <option *ngFor="let option of dropdownOptions" [value]="option">{{ option }}</option>
                    </ng-container>
                </select>
                <!-- <select *ngIf="!isGrokCloudMember">
                    <option value="" disabled selected [value]="organizationName">{{organizationName}}</option>
                </select> -->
            </div>
            <div class="floating-input relative mb-10 flex flex-col">
                <label class="block text-sm font-medium text-gray-500 p-3">Organization Name</label>
                <input class="input-style p-3" placeholder="Organization Name" formControlName="orgName" [ngClass]="outlineOrgName ? 'outline' : ''" (focus)="onFocus('orgName')">
            </div>
            <div class="p-4 flex justify-left items-center rounded-lg">
                <input id="checkbox-data-capture" type="checkbox" value="true" formControlName="isDataCaptureEnabled"
                    (change)="($event)"
                    class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="checkbox-data-capture" style="margin-left: 10px;" class="text-md mb-5 mt-6">
                     Data Capture
                </label>
                <div class="mr-4"></div>
                <input id="checkbox-data-visualization" type="checkbox" formControlName="isDataVisualizationEnabled" value="true"
                    (change)="($event)"
                    class="w-8 h-8 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                <label for="checkbox-data-visualization" style="margin-left: 10px;" class="text-md mb-5 mt-6">
                    Data Visualization
                </label>
            </div>
            <div class="flex">
                <button  class="mr-2 text-white btn-1 bg-greenish-blue">
                  <!-- <span >Create Org</span> -->
                  <span>Update</span>
                </button>
                <button class="btn-2 mr-2 text-white" (click)="onCancel()">Cancel</button>
              </div>
        </form>
    </div>
</div>